import { PurchaseConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PurchaseConstant.SET_PURCHASE:
      return { ...state, detail: payload };
    case PurchaseConstant.SET_PURCHASES:
      return { ...state, list: payload };
    default:
      return state;
  }
};
